import React, { useState, useEffect } from "react";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { app } from '../../../credenciales';
import { Button, Table, Container, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import style from "../../Actividades/Actividades.module.css";

const QrScanner = () => {
  const [actividades, setActividades] = useState([]);
  const [loading, setLoading] = useState(true);

  const getActividades = async () => {
    const db = getFirestore(app);
    const actividadesCollection = collection(db, "actividades");

    try {
      const responseDb = await getDocs(actividadesCollection);
      const actividadesList = responseDb.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const rol = parseInt(sessionStorage.getItem("userRole"));
      const correo = sessionStorage.getItem("correo");

      let actividadesFiltradas = [];

      if (rol === 1) {
        // Admin: muestra todas las actividades
        actividadesFiltradas = actividadesList;
      } else if (rol === 3) {
        // Profesor: muestra solo las actividades en las que está anotado en alguna fecha
        actividadesFiltradas = actividadesList.filter((actividad) =>
          actividad.fechas?.some((fecha) =>
            fecha.profesores?.some((prof) => prof.id === correo)
          )
        );
      }

      setActividades(actividadesFiltradas);
    } catch (error) {
      console.error("Error al obtener las actividades:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const rol = sessionStorage.getItem("userRole");
    const correo = sessionStorage.getItem("correo");

    if (!rol || !correo) {
      console.error("Faltan datos de sesión");
      setLoading(false);
      return;
    }

    getActividades();
  }, []);

  return (
    <Container className="py-4">
      <h1 className={`my-4 ${style.title}`}>¿En cuál actividad desea tomar el presente?</h1>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      ) : actividades.length > 0 ? (
        <Table striped bordered hover responsive className="shadow-sm">
          <thead className="table-dark">
            <tr>
              <th>Nombre de la actividad</th>
            </tr>
          </thead>
          <tbody>
            {actividades.map((actividad) => (
              <tr key={actividad.id}>
                <td>
                  <NavLink to={`/qrPage/${actividad.id}`} className={style.links}>
                    {actividad.nombre}
                  </NavLink>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="text-center text-muted">No hay actividades disponibles para tomar el presente.</p>
      )}
    </Container>
  );
};

export default QrScanner;
